/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { Injectable } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import {
  ApplyData,
  ApplyDataSuccess,
  GetAnnotationSettingsFromXMLFile,
  GetAnnotationSettingsFromXMLFileSuccess,
  GetFittingsTagLocationPath,
  GetFittingsTagLocationPathSuccess,
  GetRevitInformation,
  GetRevitInformationSuccess,
  GetTagLocationPath,
  GetTagLocationPathSuccess,
  IsCurrentSelectionValid,
  IsCurrentSelectionValidSuccess,
  SaveAnnotationSettingsToXmlFile,
  SaveAnnotationSettingsToXmlFileSuccess,
} from './annotation-settings-actions';
import { concatMap, from, map } from 'rxjs';
import { AnnotationSettingsService } from '../../../../../utils/src/lib/sysque-backend/annotation-settings.service';

@Injectable()
export class AnnotationSettingsEffects {
  constructor(
    private readonly actions$: Actions,
    private annotationSettingService: AnnotationSettingsService
  ) {}

  getAnnotationSettings$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(GetAnnotationSettingsFromXMLFile),
      concatMap(() =>
        this.annotationSettingService
          .getAnnotationSettings()
          .pipe(map((data) => data && GetAnnotationSettingsFromXMLFileSuccess({ response: data })))
      )
    );
  });

  saveAnnotationSettings$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(SaveAnnotationSettingsToXmlFile),
      concatMap((action) => {
        this.annotationSettingService.saveAnnotationSettings(action.annotationSettings);
        return from([SaveAnnotationSettingsToXmlFileSuccess({ response: 'OK' })]);
      })
    );
  });

  getRevitInformation$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(GetRevitInformation),
      concatMap(() =>
        this.annotationSettingService
          .getRevitInformation()
          .pipe(map((data) => data && GetRevitInformationSuccess({ response: data })))
      )
    );
  });

  getTagLocationPath$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(GetTagLocationPath),
      concatMap(() =>
        this.annotationSettingService
          .getTagLocationPath()
          .pipe(map((data) => data && GetTagLocationPathSuccess({ response: data })))
      )
    );
  });

  getFittingsTagLocationPath$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(GetFittingsTagLocationPath),
      concatMap(() =>
        this.annotationSettingService
          .getTagLocationPath()
          .pipe(map((data) => data && GetFittingsTagLocationPathSuccess({ response: data })))
      )
    );
  });

  getIsCurrentSelectionValid$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(IsCurrentSelectionValid),
      concatMap(() =>
        this.annotationSettingService
          .isCurrentSelectionValid()
          .pipe(map((data) => data && IsCurrentSelectionValidSuccess({ response: data })))
      )
    );
  });

  applyData$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ApplyData),
      concatMap((action) => {
        this.annotationSettingService.applyData(action.selectedTab);
        return from([ApplyDataSuccess({ response: 'OK' })]);
      })
    );
  });
}
